import { useState } from 'react'
import { useAuthForm } from '@/hooks/auth/useAuthForm'
import { forgotPasswordService } from '@/services/auth'
import type { ForgotPasswordPayload } from '@/services/auth'

const useForm = () => {
  const [showConfirmation, setShowConfirmation] = useState(false)

  const authForm = useAuthForm<void, ForgotPasswordPayload>({
    mutationFn: forgotPasswordService,
    onSuccess: () => setShowConfirmation(true),
  })

  return { ...authForm, showConfirmation }
}

export default useForm
